/**
 * AdminLayout - Main layout for admin console
 *
 * Desktop-focused layout with left sidebar and right content area.
 * Sidebar contains global search and tree navigation.
 */

import { Routes, Route, Link } from 'react-router-dom';
import { AdminTreeNav } from './components/AdminTreeNav';
import { AdminDashboard } from './components/AdminDashboard';
import { AdminEntityList } from './components/AdminEntityList';
import { AdminEntityDetail } from './components/AdminEntityDetail';
import { ScraperRunList } from './components/ScraperRunList';
import { ScraperRunDetail } from './components/ScraperRunDetail';
import { WrestlerDuplicates } from './components/WrestlerDuplicates';
import { BroadcastsPage } from './components/BroadcastsPage';

export function AdminLayout() {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Left Sidebar */}
      <div className="w-80 bg-white border-r border-gray-200 flex flex-col">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <h1 className="text-xl font-bold text-gray-900">Admin Console</h1>
          <p className="text-sm text-gray-500 mt-1">System Management</p>
        </div>

        {/* Navigation Tree (scrollable) */}
        <div className="flex-1 overflow-y-auto">
          <AdminTreeNav />
        </div>

        {/* Back to App Link */}
        <div className="p-4 border-t border-gray-200">
          <Link
            to="/leagues"
            className="flex items-center justify-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm font-medium text-gray-700 transition-colors"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to App
          </Link>
        </div>
      </div>

      {/* Right Content Area */}
      <div className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/entities/:table" element={<AdminEntityList />} />
          <Route path="/entities/:table/:id" element={<AdminEntityDetail />} />
          <Route path="/scraper-runs" element={<ScraperRunList />} />
          <Route path="/scraper-runs/:id" element={<ScraperRunDetail />} />
          <Route path="/wrestler-duplicates" element={<WrestlerDuplicates />} />
          <Route path="/broadcasts" element={<BroadcastsPage />} />
        </Routes>
      </div>
    </div>
  );
}
